import type React from 'react';

import tickIconUriGreen from '/shared/images/icons/icon-tick-no-outline-green.svg';
import tickIconUriWhite from '/shared/images/icons/icon-tick-no-outline-white.svg';
import tickIconUriGreenBig from '/shared/images/icons/icon-tick-green-big.svg';

interface GetIconOptsProps {
  $hasActiveTick?: boolean;
  $active?: boolean;
  $isColumn?: boolean;
  $outline?: boolean;
}

export default function getIcon(
  $icon: React.ReactNode,
  { $hasActiveTick = false, $active = false, $isColumn = false, $outline = false }: GetIconOptsProps,
) {
  if ($hasActiveTick && $active) {
    if ($isColumn) {
      return tickIconUriGreenBig;
    }
    if ($outline) {
      return tickIconUriGreen;
    }
    return tickIconUriWhite;
  }
  return $icon;
}
